import { Controller } from "@hotwired/stimulus"

// Drag source for an employee chip that is ALREADY planned on a day cell. Dragging it onto
// another day cell MOVES the allocation there (a different day and/or a different site/task),
// handled by `planning-board-drop`.
//
// The payload is marked `kind: "move"` and carries the allocation id + its source cell so the
// board-drop controller can tell a move apart from a resource-panel create (which has no id),
// and skip a drop back onto the same cell.
export default class extends Controller {
  static values = {
    allocationId: String,
    employeeId: String,
    plannableType: String,
    plannableId: String,
    date: String,
    // Which group inside the cell the chip belongs to: the demand it fulfils, or "" when it is
    // freestanding. A within-cell reorder only ever permutes one group.
    tradeDemandId: String,
  }

  connect() {
    this.onDragStart = this.handleDragStart.bind(this)
    this.onDragEnd = this.handleDragEnd.bind(this)
    this.element.addEventListener("dragstart", this.onDragStart)
    this.element.addEventListener("dragend", this.onDragEnd)
  }

  disconnect() {
    this.element.removeEventListener("dragstart", this.onDragStart)
    this.element.removeEventListener("dragend", this.onDragEnd)
  }

  handleDragStart(event) {
    // Must include "copy": the shared board-drop `dragover` sets dropEffect = "copy" (for the
    // resource-panel create drags). If effectAllowed were "move" only, the browser would reject
    // the drop as incompatible — the drop event never fires and the chip snaps back.
    event.dataTransfer.effectAllowed = "copyMove"
    event.dataTransfer.setData(
      "application/json",
      JSON.stringify({
        kind: "move",
        allocationId: this.allocationIdValue,
        resourceId: this.employeeIdValue,
        resourceType: "Employee",
        sourcePlannableType: this.plannableTypeValue,
        sourcePlannableId: this.plannableIdValue,
        sourceDate: this.dateValue,
        sourceTradeDemandId: this.tradeDemandIdValue,
      }),
    )

    this.element.classList.add("opacity-50", "scale-95")
  }

  handleDragEnd() {
    this.element.classList.remove("opacity-50", "scale-95")
  }
}
